import { environment } from '../../../../environments/environment'
import { GetTokenSilentlyOptions } from '@auth0/auth0-spa-js'
import { User } from '@helios/state-management'

export interface ConsoleSidenav {
  getAccessTokenSilentlyOrLogout: (
    options?: GetTokenSilentlyOptions,
  ) => Promise<string>
  isAuthenticationComplete: boolean
  user: User
}

/**
 * Load the Clearwater Console sidenav, which handles navigation to other CW apps as well as logout.
 * This is not exactly a webcomponent, but behaves very similarly due to dynamically-loaded js
 * index.html has script tag placeholders, which we find by ID, and then set the source for the appropriate environment
 * When the script loads it finds sidenavApp div, gets its configuration, and draws itself there.
 *
 * @param document - the DOM document, injected rather than pulled via Angular just to keep this code vanilla
 */
export async function loadCwConsoleSidenav(
  document: Document,
): Promise<ConsoleSidenav> {
  const waitForSideNavAuthComplete$: Promise<void> = new Promise(resolve => {
    const authCompletedHandler = () => {
      resolve()
      window.removeEventListener('cwanAuthCompleted', authCompletedHandler)
    }
    window.addEventListener('cwanAuthCompleted', authCompletedHandler)
  })

  const now = Date.now()
  const baseUrl = environment.externalComponents.sidenavBaseUrl

  const sidenavEnv = document.getElementById('sidenav-env')
  sidenavEnv?.setAttribute('src', `${baseUrl}/env.js?v=${now}`)

  const sidenavApp = document.getElementById('sidenavApp')
  if (sidenavApp == null) {
    throw Error('Cannot find sidenavApp')
  }

  const sidenavScript = document.getElementById('sidenav-src')
  sidenavScript?.setAttribute('src', `${baseUrl}/sidenavbar.js?v=${now}`)

  await waitForSideNavAuthComplete$

  return (window as unknown as { sidenav: ConsoleSidenav }).sidenav
}
